export const isAssetFolder = (item) => !!(item === null || item === void 0 ? void 0 : item.record_name);
export default isAssetFolder;
